import { type QConfigInformation } from '@exam-management/feature-qconfig-provider';

import { getLOSCombinations } from './utils';

interface UseGetSelectedLOSProps {
  chapterId: string;
  qConfigStructures: QConfigInformation['structures'];
  defaultLOS?: string[];
}

export function useGetSelectedLOSForItemSet(props: Readonly<UseGetSelectedLOSProps>) {
  const { chapterId, qConfigStructures, defaultLOS } = props;

  const combinations = getLOSCombinations({ chapterId, qConfigStructures, defaultLOS });

  return combinations;
}
